import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { InterventionHistory } from '../models/intervention-history.model';
import { InterventionHistoryState } from '../reducers/intervention-history.reducer';

export const selectInterventionHistoryState =
  createFeatureSelector<InterventionHistoryState>('interventionHistory');

export const selectInterventionHistoryById = (interventionHistoryId: number) =>
  createSelector(
    selectInterventionHistoryState,
    (interventionHistoryState) => interventionHistoryState.entities[interventionHistoryId],
  );

export const selectInterventionHistoryPageLoading = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.listLoading,
);

export const selectInterventionHistoryActionLoading = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.actionsloading,
);

export const selectLastCreatedInterventionHistoryId = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.lastCreatedInterventionHistoryId,
);

export const selectInterventionHistoryErrorState = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.error,
);

export const selectInterventionHistoryShowInitWaitingMessage = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.showInitWaitingMessage,
);

export const selectInterventionHistoryInStore = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => {
    const items: InterventionHistory[] = [];
    each(interventionHistoryState.ids, (ele) => {
      const index: number = +ele;
      items.push(interventionHistoryState.entities[index]);
    });
    return new QueryResultsModel(items, interventionHistoryState.totalCount);
  },
);

export const selectInterventionHistoryError = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.error,
);

export const selectInterventionHistoryLatestSuccessfullAction = createSelector(
  selectInterventionHistoryState,
  (interventionHistoryState) => interventionHistoryState.latestSuccessfullAction,
);
